	// document.querySelectorAll('.klaviyo_form_trigger').addEventListener('click', function (){
	// 	window._klOnsite = window._klOnsite || []; 
	// 	window._klOnsite.push(['openForm', 'TWxs4q']);
	// });

jQuery('.klaviyo_form_trigger').click(function(){
window._klOnsite = window._klOnsite || []; 
		window._klOnsite.push(['openForm', 'TWxs4q']);
});

